import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireAuth } from '../features/auth/guards.js';

export const Route = createFileRoute('/_player/wallet')({
  beforeLoad: requireAuth,
  component: WalletLayout,
});

function WalletLayout() {
  return <Outlet />;
}
